export enum MenuStyle {
  OPEN = "mega-menu-content show",
  CLOSE = "mega-menu-content",
}

export enum MenuButtonStyle {
  SELECTED = "dropbtn selected",
  UN_SELECTED = "dropbtn",
}